var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconClinicTable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6668 2.6665H12.0001C12.3537 2.6665 12.6928 2.80698 12.9429 3.05703C13.1929 3.30708 13.3334 3.64622 13.3334 3.99984V13.3332C13.3334 13.6868 13.1929 14.0259 12.9429 14.276C12.6928 14.526 12.3537 14.6665 12.0001 14.6665H4.00008C3.64646 14.6665 3.30732 14.526 3.05727 14.276C2.80722 14.0259 2.66675 13.6868 2.66675 13.3332V3.99984C2.66675 3.64622 2.80722 3.30708 3.05727 3.05703C3.30732 2.80698 3.64646 2.6665 4.00008 2.6665H5.33342",
    stroke: "#545454",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99992 1.3335H5.99992C5.63173 1.3335 5.33325 1.63197 5.33325 2.00016V3.3335C5.33325 3.70169 5.63173 4.00016 5.99992 4.00016H9.99992C10.3681 4.00016 10.6666 3.70169 10.6666 3.3335V2.00016C10.6666 1.63197 10.3681 1.3335 9.99992 1.3335Z",
    stroke: "#545454",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconClinicTable);
export default __webpack_public_path__ + "static/media/icon_clinic_table.1762c1e7c6df819bd9a33537000fb73a.svg";
export { ForwardRef as ReactComponent };